<template>
  <div>
    <footer class="footer d-flex-none d-sm-flex">
      <b-col cols="12" sm="8" class="">
        <b-row class="text">Európai Vállalkozásfejlesztési Díj Nemzeti Győztes 2023</b-row>
      </b-col>
      <b-col cols="12" sm="4">
        <img src="../assets/img/european.award.png" />
      </b-col>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  width: 100%;
  background-color: #d9eee2;
  color: var(--footer-fontcolor);
  z-index: 1001;
  flex-shrink: 0;
  padding-top: 15px;
  padding-bottom: 15px;
  margin-top: 20px;
  margin-bottom: -20px;
  min-height: 150px;
}
.text {
  font-family: Roboto;
  font-size: 48px;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: 0em;
  color: #00903c;
  display: flex;
  justify-content: center;
  padding: 0px 150px 0px 150px !important;
  margin-top: 40px;
  width: 1050px;
  text-align: left;
}

@media screen and (max-width: 1400px) {
  .text {
    padding: 0px 100px 0px 100px !important;
  }
}

@media screen and (max-width: 1250px) {
  .text {
    font-size: 40px;
    width: 800px;
  }
}

@media screen and (max-width: 992px) {
  .text {
    font-size: 32px;
    width: 650px;
  }
}

@media screen and (max-width: 767px) {
  .text {
    font-size: 20px;
    width: 500px;
  }
}

@media screen and (max-width: 576px) {
  .text {
    font-size: 24px;
    margin-top: 20px;
    width: unset;
    text-align: unset;
  }
}
</style>
